<p-fieldset legend="Atestados de desempenho">
  <div class="row">
    <label class="required col-3 col-form-label">
      Há exigência de atestados de desempenho anterior?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3" [(ngModel)]="entidade.AtestadoDesempenhoNao"
      [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
  <div class="row" *ngIf="entidade.AtestadoDesempenhoNao === 'S'">
    <div class="col-12">
      <button (click)="adicionar()" class="btn btn-sm btn-outline-primary" [disabled]="itemAtual">
        <i class="fa fa-plus"></i> Adicionar
      </button>
    </div>
  </div>
  <table class="table table-eddy table-sm" *ngIf="entidade.AtestadoDesempenhoNao === 'S'">
    <thead>
      <tr>
        <th scope="col">Lote</th>
        <th scope="col">Descrição</th>
        <th scope="col" style="width: 70px">Percentual</th>
        <th scope="col" style="width: 90px">Item do Edital</th>
        <th scope="col" style="width: 75px">Quantidade</th>
        <th scope="col" style="width: 90px"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of entidade?.AtestadoDesempenho">
        <td [style]="item.editavel ? 'vertical-align: top' : ''">
          <span *ngIf="!item.editavel">{{funcaoService.obterNomePorChave(listaLotes,item.NumeroLote)}}</span>
          <select *ngIf="item.editavel" [compareWith]="compareFn" class="form-control"
            [(ngModel)]="itemAtual.NumeroLote" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let item of listaLotes" [ngValue]="item.id">{{item.nome}}</option>
          </select>
        </td>

        <td>
          <span *ngIf="!item.editavel">{{item.AtestadoDescricao}}</span>
          <input *ngIf="item.editavel" type="text" class="form-control" [(ngModel)]="itemAtual.AtestadoDescricao"
            [ngModelOptions]="{standalone: true}">
          <button *ngIf="item.editavel" class="btn btn-sm btn-link float-right bg-transparent"
            (click)="aplicarDescricao()">
            <i class="fa fa-reply-all"></i>
          </button>
        </td>

        <td class="text-right">
          <span *ngIf="!item.editavel">{{item.AtestadoPercentual}}</span>
          <input *ngIf="item.editavel" type="text" class="form-control text-right"
            [(ngModel)]="itemAtual.AtestadoPercentual" [ngModelOptions]="{standalone: true}" unmask="typed"
            [imask]="imaskConfig">
          <button *ngIf="item.editavel" class="btn btn-sm btn-link float-right bg-transparent"
            (click)="aplicarPercentual()">
            <i class="fa fa-reply-all"></i>
          </button>
        </td>

        <td class="text-right">
          <span *ngIf="!item.editavel">{{item.AtestadoEditalItem}}</span>
          <input *ngIf="item.editavel" type="text" class="form-control text-right"
            [(ngModel)]="itemAtual.AtestadoEditalItem" [ngModelOptions]="{standalone: true}" unmask="typed"
            [imask]="imaskQtd">
          <button *ngIf="item.editavel" class="btn btn-sm btn-link float-right bg-transparent"
            (click)="aplicarItemEdital()">
            <i class="fa fa-reply-all"></i>
          </button>
        </td>

        <td class="text-right" [style]="item.editavel ? 'vertical-align: top' : ''">
          <span *ngIf="!item.editavel">{{item.AtestadoQuantidade}}</span>
          <input *ngIf="item.editavel" type="text" class="form-control text-right"
            [(ngModel)]="itemAtual.AtestadoQuantidade" [ngModelOptions]="{standalone: true}" unmask="typed"
            [imask]="imaskQtd">
        </td>

        <td class="text-right" [style]="item.editavel ? 'vertical-align: top' : ''">
          <button *ngIf="!item.editavel" (click)="visualizar(item)" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
          </button>
          <button *ngIf="!item.editavel" (click)="remover(item)" class="btn btn-sm btn-outline-primary">
            <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
          </button>
          <button *ngIf="item.editavel" (click)="salvar()" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
          </button>
          <button *ngIf="item.editavel" (click)="cancelar()" class="btn btn-sm btn-outline-primary">
            <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</p-fieldset>